import React from 'react';
import './components/Common/font/stylesheet.css'
import {
  ChakraProvider,
  Box,
  theme,
} from '@chakra-ui/react';
import About from './pages/About';
import { Routes, Route } from "react-router-dom";
import Homepage from './pages/Homepage';
import Product from './pages/Product';
import Qr from './pages/Qr';
import Contact from './pages/Contact';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Box>
        <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="about" exact element={<About />} />
            <Route path="biometric-payment" exact element={<Product/>} />
            <Route path="qr" exact element={<Qr/>} />
            <Route path='contact' exact element={<Contact/>}/>
          </Routes>
        </Box>
    </ChakraProvider>
  );
}

export default App;
